import AnimatedDualSearchTables from '@Components/Search/SearchByParty/AnimatedDualSearchTables'
import BulkAmendmentTable from '@Scenes/RightsholderScene/RightsholderOverclaim/RightsholderOverclaimSearch/components/BulkAmendmentTable'
import PartyWorksTable from '@Components/Search/SearchByParty/PartyWorksTable'
import OverclaimExtendedWorkItem from '@Components/WorkItemV2/OverclaimAndDisputes/OverclaimExtendedWorkItem'
import WorkResultsCardTable from '@Components/WorkItemV2/WorkResultsCardTable'
import CatalogCompactWorkItem from '@Components/WorkItemV2/Catalog/CatalogCompactWorkItem'
import OverclaimBulkActionControl from '@Scenes/RightsholderScene/RightsholderOverclaim/RightsholderOverclaimSearch/components/OverclaimBulkAction'
import React, { useContext } from 'react'
import { StoresContext } from '@App/contexts'
import { observer } from 'mobx-react'

interface OverclaimSearchResultsSectionProps {
    loading: boolean
    onChangeLimit: (limit: number) => void
    runSearch: () => void
}

const OverclaimSearchResultsSection = ({ loading, onChangeLimit, runSearch }: OverclaimSearchResultsSectionProps) => {
    const { overclaimSearchStore, overclaimSearchBulkActionStore, rightsholderStore } = useContext(StoresContext)

    if (overclaimSearchBulkActionStore.isAmendmentTableOpen) {
        return (
            <AnimatedDualSearchTables
                dualSearchStore={overclaimSearchStore}
                primarySearchTable={<BulkAmendmentTable />}
                secondarySearchTable={
                    <PartyWorksTable
                        searchPartyStore={overclaimSearchStore}
                        extendedCardType={OverclaimExtendedWorkItem}
                        className="bulk-amendment-grouped-overclaims-table"
                    />
                }
            />
        )
    }
    return (
        <WorkResultsCardTable
            works={overclaimSearchStore.worksRightsHolder}
            claimedShares={rightsholderStore.rightsholderClaimedShares}
            paginationInfo={overclaimSearchStore.worksRightsHolderPaginationInfo}
            limit={overclaimSearchStore.limit}
            onChangePage={runSearch}
            onChangeLimit={onChangeLimit}
            compactWorkComponentType={CatalogCompactWorkItem}
            extendedWorkComponentType={OverclaimExtendedWorkItem}
            compact={false}
            showCompactToggle={false}
            bulkActionControlSection={<OverclaimBulkActionControl />}
            loading={loading}
        />
    )
}

export default observer(OverclaimSearchResultsSection)
